import { getTranslated } from '@/common-components-src/api/reviews/review.api';
import UKToast from '@/components/UKToast';
import { useTranslation } from '@/i18n/client';
import { useStores } from '@/models';
import { useEffect, useRef, useState } from 'react';
import DotPage from './components/dot';
import LanguagePage from './components/language';
import style from './index.module.scss';
import ArrowDown from '@/assets/icons/arrow-down.svg';

interface TranslatePageProps {
  content: string;
  setTranslateContent: (translatedText: string) => void;
  onTranslationTrack: (isclick: string) => void;
}
const TranslatePage = ({
  content,
  setTranslateContent,
  onTranslationTrack,
}: TranslatePageProps) => {
  const { t } = useTranslation();
  const { countryStore } = useStores();
  const { currentLanguageData, targetTranslateLanguage, updateCurrentTranslateLanguage } =
    countryStore;
  const [targetLanguage, setTargetLanguage] = useState(currentLanguageData?.code);
  const [isTranslate, setIsTranslate] = useState<boolean>(false);
  const [isShowLanguage, setIsShowLanguage] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const isRestore = useRef(false);
  const initialContent = useRef<string>('');
  const [translateText, setTranslateText] = useState(
    currentLanguageData?.displayText ? currentLanguageData?.displayText.split('-')[0] : '',
  );

  // 只在组件首次挂载时设置 initialContent，后续不再改变
  useEffect(() => {
    if (!initialContent.current) {
      initialContent.current = content || '';
    }
  }, [content]);
  // 监听 targetLanguage 变化，重新翻译
  useEffect(() => {
    if (isTranslate && targetLanguage && content) {
      //切换语言，loading
      setIsLoading(true);
      setIsTranslate(false);
      handleTranslateWithLanguage(targetLanguage);
    }
  }, [targetLanguage]);

  // 还原翻译,不请求数据
  const handleTranslateOrigin = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    isRestore.current = true; // 标记为还原翻译操作
    setIsTranslate(false);
    // 将上一次的翻译内容（targetTranslateLanguage）重新赋值给 initialContent 并回传
    // if (targetTranslateLanguage) {
    //   initialContent.current = targetTranslateLanguage;
    // }
    setTranslateContent(initialContent.current);
  };

  // 翻译函数
  const handleTranslateWithLanguage = async (lang: string) => {
    try {
      const res = await getTranslated({ text: content, targetLang: lang });
      if (res && res.data && res.data.translatedText) {
        setTranslateContent(res.data.translatedText);
        updateCurrentTranslateLanguage(content);
        isRestore.current ? setIsTranslate(false) : setIsTranslate(true);
      } else {
        // 失败提示
        UKToast.show({
          content: t('review.translateFail'),
          icon: 'error',
        });
      }
      setIsLoading(false);
    } catch (error) {
      console.error('翻译出错:', error);
      // 失败提示
      UKToast.show({
        content: t('review.translateFail'),
        icon: 'error',
      });
      setIsLoading(false);
    }
  };

  const handleTranslate = async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    isRestore.current = false; // 标记为普通翻译操作
    setIsLoading(true);
    setIsShowLanguage(false);
    let isClick = !isTranslate ? '1' : '0';
    onTranslationTrack?.(isClick);
    if (targetLanguage && !isLoading) {
      await handleTranslateWithLanguage(targetLanguage);
    }
  };
  const handleTranslateLanguage = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    setIsShowLanguage(true);
  };
  return (
    <div className={style.review_item_content_translate}>
      {isTranslate ? (
        <button
          type='button'
          className={style.review_item_content_translate_text_btn}
          onClick={(e) => handleTranslateOrigin(e)}
        >
          {t('review.ShowOriginal')}
        </button>
      ) : (
        <button
          type='button'
          className={style.review_item_content_translate_text_btn}
          onClick={(e) => handleTranslate(e)}
        >
          {t('review.translate')}
        </button>
      )}
      {/* 三个点加载效果 */}
      {isLoading && <DotPage />}
      {isTranslate && !isLoading && (
        <>
          <div className={style.review_item_content_translate_line}></div>
          <div className={style.review_item_content_translate_wrap}>
            <button
              type='button'
              className={style.review_item_content_translate_text}
              onClick={(e) => handleTranslateLanguage(e)}
            >
              {t('review.translateTo', { language: translateText })}
              <ArrowDown className={style.arrow} />
            </button>

            {isShowLanguage && targetLanguage && (
              <LanguagePage
                code={targetLanguage}
                onClose={(params: any) => {
                  setIsShowLanguage((v) => !v); //控制下拉显示隐藏

                  setTargetLanguage(params?.code); //下拉列表，切换语言code
                  setTranslateText(params?.displayText ? params.displayText.split('-')[0] : '');
                }}
              />
            )}
          </div>
        </>
      )}
    </div>
  );
};
export default TranslatePage;
